import request from '@/utils/request'

// 조회
export function getLeaderShipProcedure(params, isProgress) {
  return request({
    url: `/api/getLeaderShipProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 예시
export function getLeaderShipProcedureSample(isProgress) {
  return request({
    url: `/api/getLeaderShipProcedureSample`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 저장
export function saveLeaderShipProcedure(params, isProgress) {
  return request({
    url: `/api/saveLeaderShipProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
// 삭제
export function deleteLeaderShipProcedure(params, isProgress) {
  return request({
    url: `/api/deleteLeaderShipProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}
// 출력
export function getLeaderShipProcedureReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: '/api/getLeaderShipProcedureReport',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}